import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './admin.component';
import { adminRoutingModule } from './admin-routing.module';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTableModule} from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule} from '@angular/cdk/drag-drop';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/middleware/common/common.service';
import { MatRadioModule } from '@angular/material/radio';
//import { SideNavigationsComponent } from './side-navigations/side-navigations.component';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { UserService } from './users/services/user/user.service';
import { ApiEndPointsUser } from './users/common/apiUrls/api-end-points';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMatDrpModule } from 'ngx-mat-daterange-picker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TableComponent } from 'src/app/middleware/common/table/table.component';
import { UserListComponent } from './users/userList/user-list.component';
import { MatListModule } from '@angular/material/list';
//import { RoleService } from '../roles/services/role.service';
//import { ApiEndPointsRoles } from '../roles/components/apiURLs/api-end-points';
import { CreateUsersComponent } from './users/createUsers/create-users.component';
import { EditUsersComponent } from './users/editUsers/edit-users.component';
import { SideNavigationsComponent } from './side-navigations/side-navigations.component';
import { PermissionListComponent } from './permissions/permisionList/permission-list.component';
import { PermissionService } from './permissions/services/permission/permission.service';
import { ApiendPointsPermission } from './permissions/common/apiUrls/apiend-points';
import { CreatePermissionViewModel } from 'src/app/viewModels/permissions/createPermissionViewModel/create-permission-view-model';
import { UpdatePermissionViewModel } from 'src/app/viewModels/permissions/updatePermissionViewModel/update-permission-view-model';
import { DeletePermissionViewModel } from 'src/app/viewModels/permissions/deletePermissionViewModel/delete-permission-view-model';
import { CreatePermissionsComponent } from './permissions/createPermissions/create-permissions.component';
import { EditPermissionsComponent } from './permissions/editPermissions/edit-permissions.component';
import { clickableColumns } from 'src/app/middleware/common/clickableColumns';
import { RolesListsComponent } from './roless/roleLists/roles-lists.component';
import { RoleDetailssComponent } from './roless/roleDetailss/role-detailss.component';
import { EditRolesComponent } from './roless/editRoles/edit-roles.component';
import { MatSliderModule } from '@angular/material/slider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ApiEndPointsRoles } from './roless/apiURLs/api-end-points';
import { RoleService } from './roless/services/role.service';
import { MultiselectVM } from 'src/app/viewModels/common/multiselect-vm';
import { OrganizationService } from './organizations/services/organization/organization.service';
import { ApiEndPointsOrganization } from './organizations/common/apiUrls/api-end-points-organization';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { AddOrganizationReqVM } from 'src/app/viewModels/organization/add-organization-req-vm';
import { GetPaginationVM } from 'src/app/viewModels/organization/get-pagination-vm';
import { DeleteOrganizationVM } from 'src/app/viewModels/organization/delete-organization-vm';
import { OrganizationListsComponent } from './organizations/orgnisationLists/organization-lists.component';
import { AddOrganizationsComponent } from './organizations/addOrganizations/add-organizations.component';
import { EditOrganizationsComponent } from './organizations/editOrganizations/edit-organizations.component';
import { CreateModuleReqVM } from 'src/app/viewModels/moduleMaster/create-module-req-vm';
import { ModuleMasterService } from './moduleMasters/services/moduleMaster/module-master.service';
import { ApiEndPointsModuleMaster } from './moduleMasters/common/apiUrls/api-end-points-module-master';
import { DeleteModuleMasterVM } from 'src/app/viewModels/moduleMaster/delete-module-master-vm';
import { ModuleListsComponent } from './moduleMasters/moduleLists/module-lists.component';
import { CreateModulesComponent } from './moduleMasters/createModules/create-modules.component';
import { EditModulesComponent } from './moduleMasters/editModules/edit-modules.component';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatTabsModule } from '@angular/material/tabs';
import { LoginDetailsComponent } from './login-details/login-details.component';

@NgModule({
  declarations: [AdminComponent,UserListComponent,CreateUsersComponent,EditUsersComponent,
     PermissionListComponent,CreatePermissionsComponent,EditPermissionsComponent,
     RolesListsComponent,RoleDetailssComponent,EditRolesComponent,
     OrganizationListsComponent,AddOrganizationsComponent,EditOrganizationsComponent,
     ModuleListsComponent,CreateModulesComponent,EditModulesComponent,
     SideNavigationsComponent,LoginDetailsComponent],
  imports: [
   CommonModule,
   adminRoutingModule,  
   SharedModule,
   DragDropModule,  
   MatDialogModule,
   MatSelectModule,
   FormsModule,
   ReactiveFormsModule, 
   MatFormFieldModule,
   MatIconModule,
   MatInputModule,
   MatProgressSpinnerModule,
   MatSlideToggleModule,   
   MatCheckboxModule,
   MatDatepickerModule,
   NgxDaterangepickerMd,
   MatButtonModule, 
   MatRadioModule,
   MatChipsModule,
   HttpClientModule,
   RouterModule,
   MatPaginatorModule,
   MatTableModule,
   MatListModule,
   MatTooltipModule,
   MatSortModule,
   MatBadgeModule,  
   FlexLayoutModule,
   MatTabsModule,
   MatMenuModule,  
   NgxMatDrpModule,   
   MatAutocompleteModule,
   DragDropModule,
   ScrollingModule, 
   MatCardModule,      
   MatExpansionModule,
   MatSliderModule,
   MatButtonToggleModule, 
   NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
     CommonService,  
     UserService,
     ApiEndPointsUser,
     Constants,
     DataSharingService,
     PaginationViewModel,   
     clickableColumns,    
    // ApiEndPointsRoles,
   
     //====Permission==//
    PaginationViewModel,
    PermissionService,
    CreatePermissionViewModel,
    UpdatePermissionViewModel,
    DeletePermissionViewModel,
    ApiendPointsPermission,

    // == roleList == //

    RoleService,
    ApiEndPointsRoles,
    //PaginationViewModel,
    //LoaderService,
    //clickableColumns,
    //ExcelServicesService,
    //RoleDetailVM,
    PermissionService,
    ApiendPointsPermission,
    MultiselectVM,
    
    // == Organization == //

    OrganizationService,
    ApiEndPointsOrganization,
    //CommonService,
    //Constants,
    //StatusConstant,
    //ReusableClasses,
    CustomvalidationService,
    //EncryptionService,
    AddOrganizationReqVM,
    GetPaginationVM,
    DeleteOrganizationVM,

    // Module == //

    CreateModuleReqVM,
    ModuleMasterService,
    ApiEndPointsModuleMaster,
    DeleteModuleMasterVM,
   // PaginationViewModel,

    EncryptionService,
    ReusableClasses,
    StatusConstant,    
    ToastrService,   
    CommonService,
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},  
  ], 

  
})
export class AdminModule { }
